import React from 'react';

type PropsType = React.SVGProps<SVGSVGElement>;

const FacebookIcon: React.FC<PropsType> = props => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M30 15C30 6.75 23.25 0 15 0C6.75 0 0 6.75 0 15C0 22.5 5.4375 28.6875 12.5625 29.8125V19.3125H8.8125V15H12.5625V11.625C12.5625 7.875 14.8125 5.8125 18.1875 5.8125C19.875 5.8125 21.5625 6.1875 21.5625 6.1875V9.9375H19.6875C17.8125 9.9375 17.25 11.0625 17.25 12.1875V15H21.375L20.625 19.3125H17.0625V30C24.5625 28.875 30 22.5 30 15Z"
      fill="currentColor"
    />
  </svg>
);

export default FacebookIcon;
